<template>
  <div class="mallManagement">
    <div class="main">
      <div class="side-con">
        <ul>
          <li :class="nowIdx == index ? 'active' : ''" v-for="(item, index) in newData" :key="item.path"
            @click="setChildData(item.children ? item.children : [], index)">
            <router-link :to="item.path" class="">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
        <div style="width: 100%; height: 100px;" @click="settlpay"></div>
      </div>

      <transition name="el-fade-in-linear">
        <div class="side-left" v-if="child_status">
          <ul class="side-left-con">
            <!-- <router-link
              v-for="(child, index) in childData"
              :key="index"
              :to="child.path"
            >
              <li
                @click="setChild(index)"
                :class="setChildIdx == index ? 'active' : ''"
              >
                <span>{{ child.name }}</span>
                <i v-if="setChildIdx == index" class="el-icon-caret-right"></i>
              </li>
            </router-link> -->
            <div v-for="(child, index) in childData" :key="index" class="son">
              <div class="li" v-if="!child.children" @click="setChild(child.name, child.path)" :class="setChildIdx == child.name
                  ? 'active marginTop20'
                  : 'father marginTop20'
                ">
                <span>{{ child.name }}</span>
                <i v-if="setChildIdx == child.name" class="el-icon-caret-right"></i>
              </div>
              <div class="li2" v-else>
                <span>{{ child.name }}</span>
              </div>
              <div class="li" v-for="(son, sonIndex) in child.children" :key="sonIndex"
                @click="setChild(son.name, son.path)" :class="setChildIdx == son.name ? 'active' : ''">
                <span>{{ son.name }}</span>
                <i v-if="setChildIdx == son.name" class="el-icon-caret-right"></i>
              </div>
            </div>
          </ul>
          <div style="height: 40px;width: 100%;"></div>
        </div>
        <div v-else></div>
      </transition>

      <div class="rgt-con" :class="{ 'rgt-con-2': !child_status }">
        <transition name="el-fade-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="15%" :show-close="false" :close-on-press-escape="false"
      :close-on-click-modal="false" destroy-on-close>
      <el-input v-model="psw" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="clocan">取 消</el-button>
        <el-button type="primary" @click="queding">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { initSideBar } from "./initConfig";
import { pageSet, privacy } from "@/api/set";

export default {
  inject: ["reload"],
  name: "merchants",
  computed: {
    ...mapGetters(["crumbsCont", "token", "app_id", "pageLimit", "newData"]),
  },
  watch: {
    classid: function (val) {
      console.log("我变换classID", val);
    },
  },
  data() {
    return {
      dialogVisible: false,
      psw: "", //多账户设置 20220106
      IsShow: 0,
      isCollapse: false,
      classid: this.$route.params.id, //分类
      // newData: [],
      childData: [],
      nowIdx: "",
      setChildIdx: "",
      child_status: false,
      initSideBar: initSideBar, // 导航数据
      isShowJiaoBan: 1,
      isShowYuE: 1,
    };
  },
  created() {
    if (sessionStorage.getItem("routerIdx")) {
      this.nowIdx = sessionStorage.getItem("routerIdx");
      this.setChildIdx = sessionStorage.getItem("mychild");
      if (sessionStorage.getItem("childRouter")) {
        this.child_status = true;
        this.childData = JSON.parse(sessionStorage.getItem("childRouter"));
        console.log(sessionStorage.getItem("childRouter"));
      }
    }
  },
  async mounted() {
    console.log('123------------', this.newData, this.newDatas, this.$route.name)
    // this.newData = this.pageLimit.status
    //   ? this.pageLimit.pathData
    //   : this.initSideBar.vipData;
    // if (this.newDatas.length === 0) { 
    //   this.newData = initSideBar.vipData
    // } else {
    //   this.newData = this.newDatas
    // }
    if (this.$route.name == "home") {
      setTimeout(()=>{
        this.$router.push(this.newData[0].path);
      },1000)
      
      sessionStorage.setItem("routerIdx", 0);
    }
    // console.log("数据agent", this.$route);
    // if (this.agent == 0) {
    //   this.configuration();
    // }
    this.getshowButton();
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
    // 侧边栏子数据
    async setChildData(data, idx) {
      sessionStorage.setItem("routerIdx", idx);
      console.log("侧边栏", data, idx);
      if (data.length > 0) {
        // console.log("侧边id", idx, data);
        this.child_status = true;
        this.childData = data;
        const res = await privacy({ app_id: this.app_id });
        if (res.code == 200) {
          if (this.newData[idx].name == "门店") {
            let index = this.childData.findIndex((x) => x.name == "交班记录");
            if (res.data.duty_logs == 0) {
              if (index != -1) {
                this.childData.splice(index, 1);
              }
            } else {
              if (index == -1) {
                this.childData.push({
                  path: "/apply/newVip/13/home/changeDutyList",
                  name: "交班记录",
                });
              }
            }
          }
          if (this.newData[idx].name == "订单") {
            let index1 = this.childData.findIndex((x) => x.name == "余额记录");
            let index2 = this.childData.findIndex((x) => x.name == "积分记录");
            let index3 = this.childData.findIndex((x) => x.name == "当前班次");
            let index4 = this.childData.findIndex((x) => x.name == "最近班次");
            let index5 = this.childData.findIndex((x) => x.name == "消费订单");
            let index6 = this.childData.findIndex((x) => x.name == "充值订单");
            let index7 = this.childData.findIndex((x) => x.name == "普通订单");
            if (res.data.balance_logs == 0) {
              if (index1 != -1) {
                this.childData.splice(index1, 1);
              }
            } else {
              if (index1 == -1) {
                this.childData.push({
                  path: "/apply/newVip/13/order/balanceLog",
                  name: "余额记录",
                });
              }
            }
            if (res.data.point_logs == 0) {
              if (index2 != -1) {
                this.childData.splice(index2, 1);
              }
            } else {
              if (index2 == -1) {
                this.childData.push({
                  path: "/apply/newVip/13/order/pointLog",
                  name: "积分记录",
                });
              }
            }
            if (res.data.normal_list == 0) {
              if (index7 != -1) {
                this.childData.splice(index7, 1);
              }
            } else {
              if (index7 == -1) {
                this.childData.unshift({
                  path: "/apply/newVip/13/order/ordinaryList",
                  name: "普通订单",
                });
              }
            }
            if (res.data.recharge_list == 0) {
              if (index6 != -1) {
                this.childData.splice(index6, 1);
              }
            } else {
              if (index6 == -1) {
                this.childData.unshift({
                  path: "/apply/newVip/13/order/voucherList",
                  name: "充值订单",
                });
              }
            }
            if (res.data.order_list == 0) {
              if (index5 != -1) {
                this.childData.splice(index5, 1);
              }
            } else {
              if (index5 == -1) {
                this.childData.unshift({
                  path: "/apply/newVip/13/order/oilsList",
                  name: "消费订单",
                });
              }
            }
            console.log(this.childData, index4);
            if (res.data.last_duty == 0) {
              if (index4 != -1) {
                this.childData.splice(index4, 1);
              }
            } else {
              if (index4 == -1) {
                this.childData.unshift({
                  path: "/apply/newVip/13/order/recentShift",
                  name: "最近班次",
                });
              }
            }
            if (res.data.today_duty == 0) {
              if (index3 != -1) {
                this.childData.splice(index3, 1);
              }
            } else {
              if (index3 == -1) {
                this.childData.unshift({
                  path: "/apply/newVip/13/order/oilsListNow",
                  name: "当前班次",
                });
              }
            }
          }
        }

        sessionStorage.setItem("childRouter", JSON.stringify(data));
      } else {
        sessionStorage.setItem("childRouter", "");
        this.childData = [];
        this.child_status = false;
      }
      this.nowIdx = idx * 1;
      this.reload();
    },
    async getshowButton() {
      const res = await privacy({ app_id: this.app_id });
      if (res.code == 200) {
        if (res.data.duty_logs) {
          this.isShowJiaoBan = res.data.duty_logs;
        }
        if (res.data.balance_logs) {
          this.isShowYuE = res.data.balance_logs;
        }
      }
    },
    settlpay() {
      ++this.IsShow;
      if (this.IsShow == 6) {
        this.dialogVisible = true;
      }
    },
    clocan() {
      this.psw = "";
      this.IsShow = 0;
      this.dialogVisible = false;
    },
    queding() {
      //多账户列表:20220106
      if (this.psw == "20220106") {
        sessionStorage.clear();
        this.psw = "";
        this.dialogVisible = false;
        this.$router.push("/apply/newVip/13/set/tlpay_set");
      }
    },
    setChild(index, path) {
      console.log("111", index);
      this.setChildIdx = index;
      sessionStorage.setItem("mychild", index);
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.father {
  font-weight: 550;
}

.marginTop20 {
  margin-top: 10px;
}

.son {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(50, 50, 50, 0.1);
}

.mallManagement {
  height: 100%;
  position: relative;
  overflow-y: hidden;

  i {
    color: #000;
  }

  .main {
    width: 100%;
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    overflow: hidden;

    .side-con {
      min-width: 7%;
      background: #22242f;
      overflow: hidden;
      overflow-y: auto;
      padding-top: 30px;
      padding-bottom: 60px;

      ul>li {
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        padding: 0 20px;
        position: relative;

        i {
          color: #757993;
          margin-right: 5px;
        }

        a {
          width: 100%;
          display: block;
          color: #757993;
          font-weight: 400;
          box-sizing: border-box;
        }

        a:hover:after {
          content: "";
          width: 4px;
          background: #fff;
          border-radius: 2px;
          position: absolute;
          right: 10px;
          top: 25%;
          bottom: 25%;
        }
      }

      li.active a,
      li.active i {
        color: #fff;
      }

      li.active a:after {
        content: "";
        width: 4px;
        background: #fff;
        border-radius: 2px;
        position: absolute;
        right: 10px;
        top: 25%;
        bottom: 25%;
      }
    }

    .side-left {
      min-width: 132px;
      height: 100vh;
      background: #fafafa;
      overflow: auto;

      .side-left-con {
        width: 100%;
        display: flex;
        padding: 20px 20px;
        flex-direction: column;

        div {
          width: 100%;

          .li {
            width: 100%;
            height: 42px;
            cursor: pointer;
            text-align: center;
            position: relative;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            //padding: 0 10px;
            justify-content: space-between;
          }

          .li:hover {
            color: #ffa41b;
            opacity: 1;
            background: #ededed;
          }

          .li.active {
            color: #35323b;
            background: #e9eaf0;
            border-radius: 6px;
          }

          .li2 {
            width: 100%;
            height: 42px;
            text-align: center;
            position: relative;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            padding: 0 10px;
            justify-content: space-between;
            font-weight: 550 !important;
          }
        }
      }
    }

    .rgt-con {
      min-width: calc(100% - 230px);
      position: relative;
      flex: 1;
    }

    .rgt-con-2 {
      width: calc(100% - 130px);
    }
  }
}
</style>

<style lang="scss">
.mallManagement {
  .el-menu-item-group__name {
    padding: 0;
  }
}
</style>
